import { TableRow, TableCell } from '@mui/material';

import { formatSecondsToHHMM2 } from '../../../helpers';
import { FORTA_BLACK, FORTA_ERROR } from '../../../utils/colors';
import { NOT_AVAILABLE } from '../../../pages/constants';

interface AllClientViewRowProps {
  id: string;
  name: string;
  sessionHours: number;
  clientSNHours: number;
  csnSnRatio: number;
  parentSNHours: number;
  caHours: number;
  gpsnHours: number;
}

const AllClientViewRow = ({
  name,
  sessionHours,
  clientSNHours,
  csnSnRatio,
  parentSNHours,
  caHours,
  gpsnHours,
}: AllClientViewRowProps) => {
  const csnSnRatioVal = csnSnRatio === null ? NOT_AVAILABLE : Number((csnSnRatio * 100).toFixed(2));
  return (
    <TableRow>
      <TableCell sx={{ width: '15.4%' }}>{name}</TableCell>
      <TableCell sx={{ width: '14%' }}>{formatSecondsToHHMM2(sessionHours)}</TableCell>
      <TableCell sx={{ width: '14%' }}>{formatSecondsToHHMM2(clientSNHours)}</TableCell>
      <TableCell
        sx={{
          width: '14%',
          color:
            csnSnRatioVal !== NOT_AVAILABLE && Number(csnSnRatioVal) < 5
              ? FORTA_ERROR
              : FORTA_BLACK,
        }}
      >
        {csnSnRatioVal === NOT_AVAILABLE ? csnSnRatioVal : `${csnSnRatioVal}%`}
      </TableCell>
      <TableCell sx={{ width: '14%' }}>{formatSecondsToHHMM2(parentSNHours)}</TableCell>
      <TableCell sx={{ width: '14%' }}>{formatSecondsToHHMM2(caHours)}</TableCell>
      <TableCell sx={{ width: '14%' }}>{formatSecondsToHHMM2(gpsnHours)}</TableCell>
    </TableRow>
  );
};

export default AllClientViewRow;
